import { keysToCamelCase } from 'shared/utils/api'

const adaptGetGuideResponse = keysToCamelCase

export {
  adaptGetGuideResponse,
}
